import { render, staticRenderFns } from "./risk-final-approval.vue?vue&type=template&id=13880664&scoped=true&"
import script from "./risk-final-approval.vue?vue&type=script&lang=js&"
export * from "./risk-final-approval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13880664",
  null
  
)

export default component.exports